import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './SortOrderFilter.module.scss';

function SortOrderFilter(props) {
  const [order, setOrder] = useState(props.sortOrder || 'asc');

  const handleClick = () => {
    const newOrder = order === 'asc' ? 'desc' : 'asc';
    setOrder(newOrder);
    props.onChange(newOrder);
  };

  return (
    <button onClick={handleClick} className={styles.sort}>
      <span className={cn('ic-sort', order === 'asc' ? styles.reverse : '')} />
    </button>
  );
}

export default SortOrderFilter;

SortOrderFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  sortOrder: PropTypes.string,
};
